var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "footer",
    { staticClass: "global-footer-container" },
    [
      _c("copyright-notification"),
      _vm._v(" "),
      _c("page-top-scroll", {
        attrs: { "top-scroll-element-id": _vm.topScrollElementId },
      }),
      _vm._v(" "),
      _c("sns-account-link"),
      _vm._v(" "),
      _c("copyright"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }